/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPNursingRecord from './intra-op-nursing-record';
import IntraOPNursingRecordDetail from './intra-op-nursing-record-detail';
import IntraOPNursingRecordUpdate from './intra-op-nursing-record-update';
import IntraOPNursingRecordDeleteDialog from './intra-op-nursing-record-delete-dialog';

const IntraOPNursingRecordRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPNursingRecord />} />
    <Route path="new" element={<IntraOPNursingRecordUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPNursingRecordDetail />} />
      <Route path="edit" element={<IntraOPNursingRecordUpdate />} />
      <Route path="delete" element={<IntraOPNursingRecordDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPNursingRecordRoutes;
